import '.a0{height:100vh;}.ssr-plugin'
import '.a1{height:min(50rem, 90vh);}.ssr-plugin'
import { Authentication } from '@app/components/blocks/authentication/Authentication'
import { AuthTab } from '@app/components/blocks/authentication/authTabs'
import { pages } from '@app/util/links'
import { ClientOnly } from '@based/sdk'
import { styled } from 'inlines'
import { useEffect } from 'react'
import { useLocation } from 'wouter'
import { useUserContext } from '@app/util/hooks/useUserContext'

export const AuthPage = ({
  tab,
  redirectTo,
}: {
  tab: AuthTab
  redirectTo?: string
}) => {
  const [_, navigate] = useLocation()
  const { isAuthenticated, isLoading } = useUserContext()

  useEffect(() => {
    if (isAuthenticated && !isLoading) {
      navigate(pages.home)
    }
  }, [isAuthenticated, isLoading, navigate])
  return (
    <ClientOnly>
      <div className="a0"
      >
        <div className="a1">
          <Authentication tab={tab} redirectTo={redirectTo} />
        </div>
      </div>
    </ClientOnly>
  )
}
